<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Skin and Bone</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By TA Moore</p>
<p class="P_Norm-NoIndent">Digging Up Bones: Book Two</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Cloister Witte and his K-9 partner, Bourneville, find the lost and bring them home.</p>
<p class="P_Normal">But the job doesn’t always end there.</p>
<p class="P_Normal">Janet Morrow, a young trans woman, lies in a coma after wandering away from her car during a storm. But just because Cloister found the young tourist doesn’t mean she’s home. What brought her to Plenty, California… and who didn’t want her to leave?</p>
<p class="P_Normal">With the help of Special Agent Javi Merlo, who continues to deny his growing feelings for the rough-edged deputy, Cloister unearths a ten-year-old conspiracy of silence that taps into Plenty’s history of corruption.</p>
<p class="P_Normal">Janet Morrow’s old secrets aren’t the only ones coming to light. Javi has tried to put his past behind him, but some people seem determined to pull his skeletons out of the closet. His dark history with a senior agent in Phoenix complicates not just the investigation but his relationship with Cloister.</p>
<p class="P_Normal">And since when has he cared about that?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?9abef006